import { render, staticRenderFns } from "./LinkedAccounts.vue?vue&type=template&id=5680d3de&scoped=true"
import script from "./LinkedAccounts.vue?vue&type=script&lang=ts"
export * from "./LinkedAccounts.vue?vue&type=script&lang=ts"
import style0 from "./LinkedAccounts.vue?vue&type=style&index=0&id=5680d3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680d3de",
  null
  
)

export default component.exports